import React, { FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import MultiFileDropzone, {
  IMultiFileDropzoneProps,
} from 'transfix-ui/components/MultiFileDropzone'

type IBaseControllerProps = ControllerProps<React.ComponentType<IMultiFileDropzoneProps>>

export interface IControlledMultiFileDropzoneProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  MultiDropzoneProps?: Partial<IMultiFileDropzoneProps>
}

/**
 * Helper component for use with React Hook Form
 * @see https://react-hook-form.com/api#Controller
 * @example
 * ```
 * <ControlledMultiFileDropzone
 *   name='file'
 *   control={control}
 *   defaultValue={[]}
 *   DropzoneProps={{
 *     dropzoneText: 'Drag and drop files here or click to upload',
 *   }}
 * />
 * ```
 */
const ControlledMultiFileDropzone: FC<IControlledMultiFileDropzoneProps> = ({
  control,
  defaultValue = [],
  name,
  MultiDropzoneProps = {},
}) => {
  const { dropZoneText = 'Upload', ...rest } = MultiDropzoneProps || {}

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        return (
          <MultiFileDropzone
            dropZoneText={dropZoneText}
            onFileChange={onChange}
            value={value}
            {...rest}
          />
        )
      }}
    />
  )
}

export default ControlledMultiFileDropzone
